import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ModeToggle } from 'components/styles/theme-toggle';
import type { NavSecondaryItem } from './types';

import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from 'components/ui/sidebar';

export function NavSecondary({
    items,
    ...props
}: {
    items: NavSecondaryItem[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
    const location = useLocation();

    const isActive = (url: string) => {
        return location.pathname.startsWith(url);
    };

    return (
        <SidebarGroup {...props}>
            <SidebarGroupContent>
                <SidebarMenu>
                    <>
                        {items.map((item) => (
                            <SidebarMenuItem key={item.title}>
                                <SidebarMenuButton
                                    asChild
                                    size="sm"
                                    isActive={isActive(item.url)}
                                >
                                    <Link to={item.url}>
                                        <item.icon />
                                        <span>{item.title}</span>
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        ))}
                        <ModeToggle />
                    </>
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
